import { useInfiniteHits, useInstantSearch } from 'react-instantsearch';

import { Error } from '~/apps/product-plus/components/error/Error.tsx';
import { type BettingInsightsResult, type EsIndex } from '~/apps/product-plus/configuration/types';

export function BettingInsightsErrorState<TIndex extends EsIndex, TResult extends BettingInsightsResult<TIndex>>({
  indexName,
}: {
  indexName: TIndex;
}) {
  const { items } = useInfiniteHits<TResult>();
  const { status } = useInstantSearch();

  const hasResults = Boolean(items.length);
  const isLoadingResults = status !== 'idle';
  const shouldShowErrorState = !hasResults && !isLoadingResults;

  if (!shouldShowErrorState) {
    return null;
  }

  return <Error indexName={indexName} />;
}
